import React, { Component } from "react";
import { connect } from "react-redux";
import { getAllSliders } from "../store/actions/slider";
import { PUBLIC_URL } from "../config";
import { Link } from "react-router-dom";

class Carousel extends Component {
  componentDidMount() {
    !this.props.slider.sliders && this.props.getAllSliders();
  }

  render() {
    if (this.props.slider.fetching) return null;

    return (
      <div className={"row"}>
        <div
          id="carouselExampleControls"
          className={"carousel slide"}
          data-ride="carousel"
        >
          <div className={"carousel-inner"}>
            {this.props.slider.sliders &&
              this.props.slider.sliders.map(
                ({ image, title, content, link }, index) => (
                  //title: { color: String, text: String },
                  // content: { color: String, text: String },
                  // link: { color: String, text: String, url: String, bg: String },
                  <div
                    className={
                      index === 0 ? "carousel-item active" : "carousel-item"
                    }
                    key={index}
                  >
                    <img
                      alt={"Slider"}
                      className={"d-block w-100"}
                      src={PUBLIC_URL(image)}
                    />
                    <div className="carousel-caption">
                      <h3
                        className="carousel-caption-headline"
                        style={{ color: title.color || "#FFF" }}
                      >
                        {title.text}
                      </h3>
                      <p
                        className="carousel-caption-content"
                        style={{ color: content.color || "#FFF" }}
                      >
                        {content.text}
                      </p>
                      {link.text && (
                        <Link
                          to={link.url}
                          style={{
                            backgroundColor: link.bg || "#66cc33",
                            color: link.color || "#FFF",
                          }}
                          className="carousel-caption-button btn btn-success"
                        >
                          {link.text}
                        </Link>
                      )}
                    </div>
                  </div>
                )
              )}
          </div>
          <a
            className={"carousel-control-prev"}
            href="#carouselExampleControls"
            role="button"
            data-slide="prev"
          >
            <span className={"carousel-control-prev-icon"} aria-hidden="true" />
            <span className={"sr-only"}>Previous</span>
          </a>
          <a
            className="carousel-control-next"
            href="#carouselExampleControls"
            role="button"
            data-slide="next"
          >
            <span className="carousel-control-next-icon" aria-hidden="true" />
            <span className="sr-only">Next</span>
          </a>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ slider }) => {
  return { slider };
};

const mapDispatchToProps = { getAllSliders };

export default connect(mapStateToProps, mapDispatchToProps)(Carousel);



// WEBPACK FOOTER //
// ./src/components/Carousel.js